// extracted by mini-css-extract-plugin
export default {"overlay":"bLYJ5QMN"};